import { Navigation } from "@/components/Navigation";
import { HeroSection } from "@/components/HeroSection";
import BentoFeaturesSection from "@/components/BentoFeaturesSection";
import ComingSoonSection from "@/components/ComingSoonSection";
import { PricingSection } from "@/components/PricingSection";
import AboutSection from "@/components/AboutSection";
import { Footer } from "@/components/Footer";
import { SEO } from "@/components/SEO";
import { useAuth } from "@/contexts/AuthContext";


const Index = () => {
  const { user } = useAuth();
  
  const structuredData = {
    "@context": "https://schema.org",
    "@type": "SoftwareApplication",
    "name": "queueOS",
    "description": "Beautiful and intuitive task management platform for modern teams. Streamline workflows with smart queues, real-time collaboration, and customizable forms.",
    "url": "https://queueos.com",
    "applicationCategory": "BusinessApplication",
    "operatingSystem": "Web Browser",
    "offers": {
      "@type": "Offer",
      "price": "0",
      "priceCurrency": "USD"
    },
    "author": {
      "@type": "Organization",
      "name": "queueOS"
    }
  };

  // If user is logged out, force light mode. If logged in, follow their preference (no forced class)
  const themeClasses = user 
    ? "min-h-screen bg-background text-foreground" 
    : "min-h-screen light bg-background text-foreground";

  return (
    <div className={themeClasses} data-theme={user ? undefined : "light"}>
      <SEO 
        title="queueOS - Better Than ClickUp, Trello, Notion & Monday.com"
        description="Beautiful and intuitive task management platform for modern teams. The best alternative to ClickUp, Trello, Notion, Monday.com, Google Tasks, and Microsoft Planner. Streamline workflows with smart queues, real-time collaboration, and customizable forms."
        keywords="task management, project management, clickup alternative, trello alternative, notion alternative, monday.com alternative, google tasks alternative, microsoft planner alternative, team collaboration, workflow automation, productivity software, queue management"
        structuredData={structuredData}
        url="https://queueos.com"
      />
      
      <Navigation />
      <HeroSection />
      <BentoFeaturesSection />
      <ComingSoonSection />
      <PricingSection />
      <AboutSection />
      <Footer />
    </div>
  );
};

export default Index;
